"use client";

import { FC } from "react";

import { useStyles } from "./styles";
import { Image as TImage } from "@/types/thread";
import Image from "@/components/common/Image";

interface DesktopCarouselProps {
  images: TImage[];
  selectedIndex: number;
  onSelect(index: number): void;
}

const DesktopCarousel: FC<DesktopCarouselProps> = ({
  images,
  selectedIndex,
  onSelect,
}) => {
  const { classes, cx } = useStyles();

  return (
    <div className={classes.container}>
      {images.map((image, index) => {
        const isSelected = index === selectedIndex;
        return (
          <div
            key={`image-preview-${index + 1}`}
            onClick={() => onSelect(index)}
            className={cx(
              classes.imageContainer,
              isSelected && classes.activeImage
            )}
          >
            <Image
              src={image.url}
              alt={image.alt || ""}
              className={classes.image}
              width={140}
              height={140}
            />
          </div>
        );
      })}
    </div>
  );
};

export default DesktopCarousel;
